import { AsyncState, Unit, loadingAsyncState, unloadedAsyncState } from 'widgets-for-react'
import { getQuestions } from './jotform.api'

export type JotformState = {
  form: AsyncState<Form>
  submitted: AsyncState<Unit>
  clickedSubmit: boolean
}

export type Form = { questions: Question[]; thankurl: string }

export type Question = Field | SubmitButton

export type Field =
  | InputField
  | TextareaField
  | SelectField
  | NumberField
  | EmailField
  | PhoneNumberField
  | FullNameField
  | RadioField
  | CheckboxField

export type InputField = {
  kind: 'input'
  placeholder?: string
  maxLength?: number
} & FieldBaseWithValueAndRequired<string>

export type TextareaField = {
  kind: 'textarea'
  placeholder?: string
  maxLength?: number
} & FieldBaseWithValueAndRequired<string>

export type SelectField = {
  kind: 'select'
  placeholder?: string
  options: string[]
} & FieldBaseWithValueAndRequired<string>

export type NumberField = {
  kind: 'number'
  placeholder?: string
  minValue?: string
  maxValue?: string
} & FieldBaseWithValueAndRequired<string>

export type EmailField = {
  kind: 'email'
  placeholder?: string
  maxLength?: number
  extraConfirmationField?: FieldWithValue<string> & { label: string; placeholder?: string; showErrors: boolean }
} & FieldBaseWithValueAndRequired<string>

export type PhoneNumberField = {
  kind: 'phone'
  placeholder?: string
} & FieldBaseWithValueAndRequired<string>

export type FullNameField = {
  kind: 'fullName'
  required: boolean
  subFields: {
    prefix?: FieldWithValue<string> & { label: string; options?: string[] }
    first: FieldWithValue<string> & { label: string; placeholder?: string; showErrors: boolean }
    middle?: FieldWithValue<string> & { label: string; placeholder?: string }
    last: FieldWithValue<string> & { label: string; placeholder?: string; showErrors: boolean }
    suffix?: FieldWithValue<string> & { label: string; placeholder?: string }
  }
} & FieldBase

export type RadioField = {
  kind: 'radio'
  options: string[]
  extraOption?: FieldWithValue<string> & { label: string; showErrors: boolean }
} & FieldBaseWithValueAndRequired<string>

export type CheckboxField = {
  kind: 'checkbox'
  options: string[]
  extraOption?: FieldWithValue<string> & { label: string; showErrors: boolean }
} & FieldBaseWithValueAndRequired<string[]>

type FieldBase = {
  id: string
  label: string
  fieldMessage?: string
  readonly?: boolean
  hidden?: boolean
  showErrors: boolean
}

export type FieldBaseWithValueAndRequired<T> = FieldBase & FieldWithValueAndRequired<T>
type FieldWithValue<T> = { value: T }
type FieldWithValueAndRequired<T> = FieldWithValue<T> & { required: boolean }

type SubmitButton = {
  kind: 'submitButton'
  label: string
  hidden?: boolean
}

export const initialJotformState = (id: string): JotformState => ({
  form: loadingAsyncState(() => getQuestions(id)),
  submitted: unloadedAsyncState(),
  clickedSubmit: false,
})
